import React from 'react';
import glamorous from 'glamorous';

const ApiTechnicalDetails = () => {
  return (
	<div>
		<h3>API TECHNICAL DETAILS FOR AUTOMATED UPLOADS</h3>
		<p>
			The API implemented in the OECD <i>GlobalRecalls</i> portal enables you to automatically push the recall notices
			contained in your own recall database into the OECD portal. This functionality is subject to your system’s
			technological capacity to automatise the uploading process. You will need to ensure that your systems can use an
			API in machine-to-machine mode, which involves having the ability to automatically export the recalls, convert
			them into the right XML format, and compress them and their related picutres in ZIP format. You will also need
			to ensure that your orgnisation’s servers have the capacity to access the OECD <i>GlobalRecalls</i> portal via
			an Internet zone.
		</p>
		<p>
			If you are unsure, please speak to your local IT area or technical team. For more information, you can also
			contact the OECD Secretariat <i>via</i> email: <a href="mailto:GlobalRecallsdata@oecd.org">GlobalRecallsdata@oecd.org</a>.
		</p>
		<br/>
		<glamorous.Ul
		className="pt-list"
		css={{
		paddingLeft: 10,
		listStyle: 'disc',
		}}>
			<glamorous.Li css={{ marginBottom: 10 }}>The URL of the API is: <strong>https://globalrecalls.oecd.org/ws/import.xqy</strong></glamorous.Li>
			<glamorous.Li css={{ marginBottom: 10 }}>There is 1 inline parameter: <strong>apikey</strong> (e.g. https://globalrecalls.oecd.org/ws/import.xqy?apikey=9999999)</glamorous.Li>
			<glamorous.Li css={{ marginBottom: 10 }}>The request method is: <strong>POST</strong></glamorous.Li>
			<glamorous.Li css={{ marginBottom: 10 }}>The ZIP file to be loaded must be in the BODY of the request</glamorous.Li>
			<glamorous.Li css={{ marginBottom: 10 }}>The answer to the request is in: <strong>text/plain</strong></glamorous.Li>
		</glamorous.Ul>
		<hr/>
		<p>
			A third-party module is available that interfaces with the API of the OECD GlobalRecalls portal to allow nodes on participating jurisdictions' websites containing product recall notices to be published on the Portal in multiple languages.
			Some jurisdictions may find this helpful and more information on the module can be found here: <a href="https://www.drupal.org/project/psa_oecd_publishing" target="_blank">www.drupal.org/project/psa_oecd_publishing</a>.
			Please note that the OECD neither endorses nor requires the use of the module and the OECD does not provide any warranty or indemnity for its use.
		</p>
	</div>
  );
};

export default ApiTechnicalDetails;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/api-technical-details.js